export const DEFAULT_SORT_TYPE = 'RELEVANT';
export type PageState = 'Default' | 'Filtered';
